import Model from '@/shared/orm/Model'
import i18n from '@/plugins/i18n'
import CertificateRequest from '@/models/CertificateRequest'
import Customer from '@/models/Customer'
import Plan from '@/models/Plan'
import Period from '@/models/Period'
import Commission from '@/models/Commission'

export default class CommissionPeriod extends Model {
    resourceName() {
        return 'commissionPeriods'
    }

    fields() {
        return ['value', 'base_value', 'taxed_value']
    }

    relationships() {
        return {
            period: new Period(),
            customer: new Customer(),
            plan: new Plan(),
            certificate_request: new CertificateRequest(),
            previous_commission: new Commission(),
        }
    }

    computed() {
        return {
            formattedValue(item) {
                return i18n.n(item.value, 'currency')
            },

            formattedBaseValue(item) {
                return i18n.n(item.base_value, 'currency')
            },
        }
    }
}
